var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.615 7.432 12.793 8.13 6.18-3.902L8.085 2.01c-.76-.071-2.516.175-3.47 1.736-.954 1.56-.397 3.108 0 3.686zm5.946 20.599.04-15.158L4 8.867l.125 19.127c.344.68 1.49 2.034 3.32 2.007 1.83-.028 2.84-1.325 3.116-1.97zm.9-7.124 13.014-7.861c.7-.032 2.308.313 3.129 1.948.82 1.635.1 3.256-.362 3.862l-15.734 9.36-.046-7.309z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPla);
export default __webpack_public_path__ + "static/media/PLA.b7533d372cb3a410e4db1cbd55686fe6.svg";
export { ForwardRef as ReactComponent };